export enum PLANS {
    BASIC = 'basic',
    PRO = 'pro',
    ENTERPRISE = 'enterprise',
    TRIAL = 'trial',
    FREE = 'free',
    UNLOCKED = 'unlocked',
}

export const PLANS_LABELS = {
    [PLANS.BASIC]: 'basic_plan_label',
    [PLANS.PRO]: 'pro_plan_label',
    [PLANS.ENTERPRISE]: 'enterprise_plan_label',
    [PLANS.TRIAL]: 'trail_plan_label',
    [PLANS.FREE]: 'free_plan_label',
};

export interface UserOrder {
    amount: number;
    created: string;
    currency: string;
    id: number;
    label: string;
    memberId: number;
    payerEmail: string;
    paypalId: string;
    paymentMethod: 'FreeBee' | 'Stripe' | 'PayPal' | 'CoinPayments';
}

export enum SUBSCRIPTION_DURATION {
    MONTHLY = 'monthly',
    YEARLY = 'yearly',
    DIRECT = 'direct',
    FREEBIE = 'freebie',
}

export enum PAYMENT_PERIOD {
    MONTH = 'month',
    THREE_MONTHS = '3month',
    SIX_MONTHS = '6month',
    TWELVE_MONTHS = '12month',
    YEAR = 'year',
}

export enum API_PAYMENT_PERIOD {
    MONTH = 'month',
    THREE_MONTH = 'three_month',
    SIX_MONTH = 'six_month',
    YEAR = 'year',
}

export const SUBSCRIPTION_DURATION_LABELS = {
    [SUBSCRIPTION_DURATION.MONTHLY]: 'monthly_label',
    [SUBSCRIPTION_DURATION.YEARLY]: 'annual_label',
    [SUBSCRIPTION_DURATION.DIRECT]: 'direct_label',
    [SUBSCRIPTION_DURATION.FREEBIE]: 'freebie_label',
    [PAYMENT_PERIOD.YEAR]: 'annual_label',
    [PAYMENT_PERIOD.MONTH]: 'monthly_label',
};

export enum PAYMENT_METHOD {
    PAYPAL = 'paypal',
    CRYPTO = 'coinpayment',
    STRIPE = 'stripe',
    FREEBIE = 'freebee',
}

export enum HT_PAYMENT_PROVIDER {
    STRIPE = 'stripe',
    COINPAYMENTS = 'coinpayments',
    LLAMAPAY = 'llamapay',
}

export interface Price {
    longLabel: string;
    currency: string;
    price: number;
    duration: SUBSCRIPTION_DURATION;
    accountType: PLANS;
}

export enum HYPERTRACKER_API_PLANS {
    FREE = 'free',
    PULSE = 'pulse',
    SURGE = 'surge',
    FLOW = 'flow',
    STREAM = 'stream',
}

export const API_PLANS_ORDER: HYPERTRACKER_API_PLANS[] = [
    HYPERTRACKER_API_PLANS.FREE,
    HYPERTRACKER_API_PLANS.PULSE,
    HYPERTRACKER_API_PLANS.SURGE,
    HYPERTRACKER_API_PLANS.FLOW,
    HYPERTRACKER_API_PLANS.STREAM,
];

export interface HypertrackerPrice {
    price: string;
    duration: API_PAYMENT_PERIOD;
    longLabel: string;
    code: ALERT_PLANS;
}

export interface HypertrackerPriceResponse {
    prices: HypertrackerPrice[];
}

export enum APP_FOR_PAYMENT {
    HYPERTRACKER = 'hypertracker',
    HYPERTRACKER_API = 'hypertracker_api',
}

export interface HypertrackerPriceResponse {
    prices: HypertrackerPrice[];
}

export interface ActiveHTSubscriptionsResponse {
    prices: HypertrackerPrice[];
}

export enum ALERT_PLANS {
    BASED_UNLIMITED = 'unlimited',
    HYPERLIQUID = 'hyperliquid',
    BASIC = 'basic',
    SCOUT = 'scout',
    PRO_TRACKER = 'pro_tracker',
}

export enum SUBSCRIPTION_STATUS {
    OPENED = 'opened',
    AUTHORIZED = 'authorized',
    PAID = 'paid',
    CANCELLED = 'cancelled',
    EXPIRED = 'expired',
    FAILED = 'failed',
    PENDING = 'pending_authorization',
}

export interface Subscription {
    created: string;
    updated: string;
    lastCharge: string;
    orderType: PLANS;
    duration: SUBSCRIPTION_DURATION;
    status: SUBSCRIPTION_STATUS;
    id: string | number;
    memberId: number;
    amount: number;
    wasCharged: boolean;
    paymentMethod: PAYMENT_METHOD;
    recurring: false;
    expires: string;
}

export interface Discount {
    id: number;
    discountPrice: number;
    originalPrice: number;
    couponCode: string;
    duration: SUBSCRIPTION_DURATION;
    label: string;
    accountType: PLANS;
}

export interface PaymentState {
    userOrders: UserOrder[];
    prices: Price[];
    subscription: Subscription | null;
    discountCoupons: string;
    discountPercentage: number;
    nonRedeemedCoupons: Discount[];
}

export interface UpgradeLine {
    amount: string;
    description: string;
    discountAmount: string;
}

export interface UpgradeState {
    total: number | string;
    lines: UpgradeLine[];
}
